module.exports = __webpack_public_path__ + "static/media/foot-right.8e7a63d9.svg";